import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainForm from './pages/MainForm';
import FinanceHomePage from './pages/FinanceHomePage';
import ReportForm from './pages/ReportForm';
import ReportBillingPage from './pages/ReportBillingPage';
import MachineForm from './pages/MachineForm';
import SparePartsForm from './pages/SparePartsForm';
import SettingsForm from './pages/SettingsForm';
import AnalyticsPage from './pages/AnalyticsPage';
import LoginForm from './pages/LoginForm';
import CustomerSignaturePage from './pages/CustomerSignaturePage';
import { authService } from './services/authService';
import './i18n/config';
import './App.css';

// Protected Route wrapper
const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// T-017: FINANCE atterra sulla propria home dedicata, tutti gli altri ruoli sulla dashboard generica.
// FINANCE raggiunge comunque la dashboard tecnica su /dashboard (vedi getDashboardPath).
const HomeRoute: React.FC = () => {
  const isFinance = authService.getCurrentUser()?.role === 'FINANCE';
  return isFinance ? <FinanceHomePage /> : <MainForm />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/sign/:token" element={<CustomerSignaturePage />} />
          <Route path="/" element={<ProtectedRoute><HomeRoute /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><MainForm /></ProtectedRoute>} />
          <Route path="/billing" element={<ProtectedRoute><FinanceHomePage /></ProtectedRoute>} />
          <Route path="/report/:id" element={<ProtectedRoute><ReportForm /></ProtectedRoute>} />
          <Route path="/report/:id/billing" element={<ProtectedRoute><ReportBillingPage /></ProtectedRoute>} />
          <Route path="/report/:reportId/machine/:machineId" element={<ProtectedRoute><MachineForm /></ProtectedRoute>} />
          <Route path="/report/:reportId/machine/:machineId/spareparts" element={<ProtectedRoute><SparePartsForm /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsForm /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
